import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BigProgress from "components/BigProgress";
import SnackbarMsg from "components/SnackbarMsg";
// import SnackbarMsgHistory from "components/SnackbarMsgHistory";
import WindowConfirm from "components/WindowConfirm";
import WindowAlert from "components/WindowAlert";
import WindowPrompt from "components/WindowPrompt";
import WindowButtons from "components/WindowButtons";
import MultiSnackbarMsg from "components/MultiSnackbarMsg";

// Lazy load components
const HomePage = lazy(() => import("containers/home/HomePage"));
const LoginPage = lazy(() => import("containers/login/LoginPage"));
const LoginFsPage = lazy(() => import("containers/login/LoginFsPage"));
const MapPage = lazy(() => import("containers/map/MapPage"));
const Upload = lazy(() => import("containers/publicPage/Upload"));
const ResetPassword = lazy(() => import("containers/publicPage/ResetPassword"));
const ResetPasswordSuper = lazy(() => import("containers/publicPage/ResetPasswordSuper"));
// const GatewayDetailPage = lazy(() => import("containers/gateway/GatewayDetailPage"));
// const LightDetailPage = lazy(() => import("containers/serial/LightDetailPage"));
// const SensorDetailPage = lazy(() => import("containers/sensor/SensorDetailPage"));
// const DaliCtlDetailPage = lazy(() => import("containers/daliCtl/DaliCtlDetailPage"));
// const ZoneControlDetailPage = lazy(() => import("containers/zoneCtl/ZoneControlDetailPage"));
// const BatTestTimeTablePage = lazy(() => import("containers/testReport/BatTestTimeTablePage"));
const ToolboxPage = lazy(() => import("containers/server/toolboxPage"));

export default function MainPage() {
  let curUrl = window.location.href;

  return (
    <div>
      <BrowserRouter>
        <Suspense fallback={<BigProgress />}>
          <Routes>
            <Route path="/LoginPage" element={<LoginPage />} />
            <Route path="/HomePage" element={<HomePage />} />
            <Route path="/MapPage" element={<MapPage />} />
            <Route path="/LoginFsPage" element={<LoginFsPage />} />
            {/* <Route
              path="/"
              element={
                curUrl.includes("skymon.web.app") ? (
                  <LoginFsPage />
                ) : (
                  <LoginPage />
                )
              }
            /> */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/resetPasswordSuper" element={<ResetPasswordSuper />} />
            {/* <Route path="/GatewayDetailPage" element={<GatewayDetailPage />} /> */}
            {/* <Route path="/LightDetailPage" element={<LightDetailPage />} /> */}
            {/* <Route path="/SensorDetailPage" element={<SensorDetailPage />} /> */}
            {/* <Route path="/DaliCtlDetailPage" element={<DaliCtlDetailPage />} /> */}
            {/* <Route path="/ZoneControlDetailPage" element={<ZoneControlDetailPage />} /> */}
            {/* <Route path="/BatTestTimeTablePage" element={<BatTestTimeTablePage />} /> */}
            <Route path="/ToolboxPage" element={<ToolboxPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <SnackbarMsg />
      {/* <SnackbarMsgHistory /> */}
      <MultiSnackbarMsg />
      <WindowConfirm />
      <WindowAlert />
      <WindowPrompt />
      <WindowButtons />
      <BigProgress />
    </div>
  );
}
